// extracted by mini-css-extract-plugin
export default {"container":"bk-z","blurb":"ck-z","links":"dk-z"};